import {createMuiTheme} from "@material-ui/core";
import {BLUE_COLOR_SELECTION} from "../src/utils/consts";

export const ReportRegisterTabTheme = createMuiTheme({
    palette: {
        secondary: {
            main: BLUE_COLOR_SELECTION,
        },
    },

});